export default __webpack_public_path__ + "angle-arrow-down.png";